import { render, staticRenderFns } from "./IndexItem.vue?vue&type=template&id=ff712e2e&"
import script from "./IndexItem.vue?vue&type=script&lang=js&"
export * from "./IndexItem.vue?vue&type=script&lang=js&"
import style0 from "./IndexItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports